import { formatTenThousandths, parseTenThousandths } from '@shared/utils/moneyArithmetic';

const FRACTION_DIGITS = 4;

export const sumAtScale = (amounts: readonly string[], scale: 2): string => {
    const unit = 10n ** BigInt(FRACTION_DIGITS - scale);
    let total = 0n;
    for (const amount of amounts) {
        const tenThousandths = parseTenThousandths(amount);
        if (tenThousandths === null || tenThousandths % unit !== 0n) {
            throw new Error(`Amount "${amount}" is not a ${scale}dp amount`);
        }
        total += tenThousandths;
    }
    return formatTenThousandths(total).slice(0, -(FRACTION_DIGITS - scale));
};
